<template>
  <el-container>
    <el-header>
      <div class="lt">
        <div class="logo">
          <img v-if="logoUrl" :src="logoUrl" alt />
          <img v-else src="@/assets/img/home/logo.png" alt />
        </div>
        <i :class="isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="isCollapse = !isCollapse"></i>
        <span>{{ orgName }}后台管理系统</span>
      </div>
      <div class="rt">
        <!-- <el-input
            type="text"
            placeholder="请输入搜索的文章内容"
            style="width:300px;"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>-->
        <div class="zhongxin dz-flex-center">
          <!-- <i>
            <img src="@/assets/img/home/chongzhi.png" alt style="float: left; margin: 0.45vw -1.8vw 0px 0px; height: 2.25vw" />
          </i>
          <span style="
              font-size: 0.83vw;
              font-weight: bold;
              color: rgba(246, 98, 0, 1);
              margin-right: 0.5vw;
            ">
            10220
            <span style="font-size: 0.5vw; color: #f68e00">金币</span>
          </span>
          <span class="chongzhi">
            <el-button>立即充值</el-button>
          </span>
          <span class="qiehuan">
            <el-button @click="qiehuan">切换校区</el-button>
          </span> -->
          <i class="el-icon-question"></i>
          <span class="bangzhu">帮助中心</span>
          <i class="el-icon-message-solid"></i>
          <span class="xiaoxi">消息中心</span>
        </div>
        <el-dropdown>
          <span class="el-dropdown-link">
            <!-- <img :src="photo" alt width="40" height="40" /> -->
            {{ name }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>校区名称：{{ orgName }}</el-dropdown-item>
            <el-dropdown-item>权限等级：{{ roleName }}</el-dropdown-item>
            <el-dropdown-item>校区数量：{{ orgNum }}</el-dropdown-item>
            <el-dropdown-item class="btn">
              <router-link to="account">账号管理</router-link>
            </el-dropdown-item>
            <el-dropdown-item class="btn" @click.native="logout()">退出账号</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside :width="isCollapse ? '3.4vw' : '10.4vw'">
        <el-menu :default-active="$route.path" :collapse="isCollapse" :collapse-transition="false" router :unique-opened="true">
          <el-menu-item index="/welcome" :style="{ width: isCollapse ? '3.4vw' : '10.4vw' }">
            <i class="iconfont icon-zu2 cxgl"></i>
            <span slot="title">首页管理</span>
          </el-menu-item>
          <fragment v-for="item in menulist" :key="item.id">
            <fragment v-if="item.submenus != null && item.submenus.length > 0">
              <el-submenu :index="item.strId" :style="{ width: isCollapse ? '3.4vw' : '10.4vw' }">
                <template slot="title">
                  <i :class="item.menuclass"></i>
                  <span>{{ item.name }}</span>
                </template>
                <fragment v-for="sub in item.submenus" :key="sub.id">
                  <el-menu-item style="padding-left: 2.1vw !important" :index="sub.path">{{ sub.name }}</el-menu-item>
                </fragment>
              </el-submenu>
            </fragment>
            <fragment v-else>
              <el-menu-item :index="item.path" :style="{ width: isCollapse ? '3.4vw' : '10.4vw' }">
                <i :class="item.menuclass"></i>
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </fragment>
          </fragment>
          <el-menu-item index="/campusmanagement" :style="{ width: isCollapse ? '3.4vw' : '10.4vw' }">
            <i class="iconfont icon-zu826 cxgl"></i>
            <span slot="title">校区管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="scrollbarStyle">
        <router-view />
        <div class="beianhao">
          Copyright © 2015-2021 麦凯思教育 All Rights Reserved. 备案号：
          <a href="https://beian.miit.gov.cn" target="_blank">
            鲁ICP备15013036号-1
          </a>
        </div>
      </el-main>
    </el-container>
    <div class="dialogStyle">
      <el-dialog title="提示" :visible.sync="isTips" width="350px" center>
        <div class="dz-flex-center dz-f20 dz-font-weight-bold">后续功能陆续开放!</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isTips = false">确 认</el-button>
        </span>
      </el-dialog>
    </div>
  </el-container>
</template>

<script>
// 导入iconfont的css文件
import '@/assets/iconfont/iconfont.css';
export default {
  name: 'home',
  data: function () {
    return {
      isTips: false,
      name: window.sessionStorage.getItem('username'),
      orgName: window.sessionStorage.getItem('orgName'),
      roleName: window.sessionStorage.getItem('roleName'),
      orgNum: window.sessionStorage.getItem('orgNum'),
      isCollapse: false,
      menulist: [],
      tempImg: '',
      // 头像
      logoUrl: window.sessionStorage.getItem('logoUrl'),
    };
  },
  mounted () {
    var self = this;
    if (!+window.sessionStorage.getItem('tipsNum')) {
      self.isTips = true;
      window.sessionStorage.setItem('tipsNum', 1);
    }
    let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
    // console.log('token===========--=' + token)
    let pro = this.$http({
      url: '/sys/user/getUserMenus',
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
    pro
      .then((result) => {
        if (result.data.code === 0) {
          // console.log('result.data===' + JSON.stringify(result.data.data))
          self.menulist = result.data.data;
        } else {
          this.$message.error(result.data.message);
        }
      })
      .catch((err) => {
        // console.log('error===============')
        this.$message.error('系统错误：' + err);
      });
  },
  methods: {
    qiehuan () {
      this.$router.push({ name: 'campusmanagement' });
    },
    logout () {
      // console.log('token=' + window.sessionStorage.getItem('userinfo'))
      // let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      this.$confirm('确认要退出系统吗?', '退出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // this.$http({
          // url: '/edu/student/deleteStudent/1',
          // method: 'POST',
          // headers: {
          //   Authorization: 'Bearer ' + token
          // }
          // })
          // 清空sessionStorage数据
          window.sessionStorage.clear();
          // 导航到登录页面
          this.$router.push({ name: 'login' });
          this.$message({
            type: 'success',
            message: '退出成功!',
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消退出',
          });
        });
    },
  },
};
</script>

<style lang="less">
.el-dropdown-menu .btn {
  width: 3vw !important;
}
.el-dropdown-menu__item {
  padding: 0 1vw;
}
.el-container {
  height: 100%;
  overflow: hidden;
  .el-header {
    background-color: white;
    display: flex;
    justify-content: space-between;
    padding: 0 0.5vw 0 9px;
    height: 3.1vw !important;
    .lt {
      height: 100%;
      width: 40%;
      background-color: white;
      display: flex;
      align-items: center;
      font-size: 24px;
      span {
        margin-left: 0.65vw;
        color: #666;
        font-size: 0.93vw;
      }
      .logo {
        margin-left: 0.5vw;
        img {
          width: 137px;
          height: 52px;
        }
      }
      .el-icon-s-unfold {
        color: #666;
        font-size: 1.3vw;
        margin-left: 3.1vw;
        line-height: 2.3vw;
      }
      .el-icon-s-fold {
        color: #666;
        font-size: 1.3vw;
        margin-left: 3.1vw;
        line-height: 2.3vw;
      }
    }
    .rt {
      height: 100%;
      width: 60%;
      background-color: white;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .zhongxin {
        font-size: 0.78vw;
        color: #666;
        height: 2.75vw;
        i {
          margin: 0 0.5vw 0 1.25vw;
        }
        .chongzhi {
          .el-button {
            background: #fff;
            width: 3.85vw;
            height: 1.35vw;
            line-height: 1.35vw;
            color: #f68e00;
            border: 1px solid rgba(246, 142, 0, 1);
            opacity: 1;
            border-radius: 0.73vw;
            padding: 0;
            font-size: 0.65vw;
            margin-top: 0.83vw;
          }
          .el-button:hover {
            color: #fff;
            background: #f68e00;
          }
        }
        .qiehuan {
          margin-left: 1.25vw;
          .el-button {
            width: 4.5vw;
            height: 1.35vw;
            line-height: 1.35vw;
            color: #00a6e6;
            border: 1px solid rgba(20, 166, 230, 1);
            opacity: 1;
            border-radius: 14px;
            padding: 0;
            padding-right: 14px;
            font-size: 0.65vw;
            margin-top: 0.83vw;
            background: url("../../assets/img/home/qiehuan_2.png") #fff
              no-repeat 3.3vw 0.4vw;
            background-size: 0.65vw;
          }
          .el-button:hover {
            color: #fff;
            background: url("../../assets/img/home/qiehuan_1.png") #00a6e6
              no-repeat 3.3vw 0.4vw;
            background-size: 0.65vw;
          }
        }
      }
      .el-dropdown {
        margin: 0 1vw;
      }

      .el-dropdown-link {
        display: flex;
        align-items: center;
        i {
          margin-right: 3.1vw;
        }
      }
    }
  }

  .el-aside {
    float: left;
    background-color: #161d3a;
    .el-menu--collapse {
      width: 3.4vw;
    }
    .el-menu {
      border: 0;
      overflow: hidden;
      color: #fff;
      // .el-menu-item,
      // .el-submenu__title {
      //   height: 2.9vw;
      //   line-height: 2.9vw;
      // }
      .el-submenu {
        // height: 3vw;
        .el-submenu__title {
          font-size: 0.8vw;
          color: #fff;
          background-color: #161d3a;
          padding: 0 0.8vw !important;
        }
        .iconfont {
          font-size: 0.85vw;
        }
      }
      .el-menu-item {
        font-size: 0.8vw;
        color: #fff !important;
        background: #161d3a;
        padding: 0 0.8vw !important;
        .el-tooltip {
          padding: 0 0.8vw !important;
        }
        .iconfont {
          font-size: 0.85vw;
        }
      }
      .el-menu-item:hover {
        background: #242b55 !important;
      }
      .el-menu-item.is-active {
        background: #0094ce !important;
      }
      .cxgl {
        margin: 0 0.75vw 0 0.2vw;
      }
    }
  }
  .el-main {
    float: right;
    background: #f1f1f1;
  }
}
.el-dropdown-menu {
  .el-dropdown-menu__item {
    font-size: 0.73vw;
    color: #666;
    line-height: 30px;
    &:hover {
      background: none;
      color: #666;
    }
  }
  .btn {
    margin: 0.65vw auto 0 auto;
    width: 52px;
    height: 22px;
    line-height: 22px;
    color: #0094ce;
    // text-align: center;
    border: 1px solid rgba(0, 148, 206, 1);
    opacity: 1;
    border-radius: 1.35vw;
    a {
      color: #0094ce;
      text-decoration: none;
    }
    &:hover {
      color: #0094ce;
    }
  }
}

.beianhao {
  color: #666;
  text-align: center;
  margin: 20px 0 10px 0;
  font-size: 14px;
  a {
    text-decoration: none;
    color: #666;
  }
  a:hover {
    color: #0090c9ff;
  }
}
</style>
